<template>
<div class="CardContainer" :style="containerStyle">
  <span v-if="isActive" class="cart-count clickable">
    <v-icon color="white" @click="clearActive"> close </v-icon>
  </span>

  <div class="RewardsCard clickable" :class="cssClass" :style="containerStyle" @click="onClick && onClick()">
    <v-layout 
      row 
      wrap 
      class="text-xs-left" 
      :style="{ height: isHeightDisabled ? 'unset' : '-webkit-fill-available' }"
    >
      <v-flex v-if="showImage" xs4 class="imageContainer">
        <v-img :src="image" @error="onImageError" />
      </v-flex>

      <v-flex :xs8="showImage" :xs12="!showImage" style="padding-left: 10px;" class="textBody">
        <slot name="textBody">
        </slot>
      </v-flex>
    </v-layout>

    <slot name="description">
    </slot>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';


export default {
  props: {
    clearActive: {
      type: Function,
      default: () => false
    },
    onClick: {
      type: Function,
      default: () => false
    },

    image: {
      type: String,
      default: null
    },


    isActive: {
      type: Boolean,
      default: false
    },

    allowConfig: {
      type: Boolean,
      default: false
    },

    showItems: {
      type: Boolean,
      default: false
    },

    immutable: {
      type: Boolean,
      default: false
    },

    maxWidth: {
      type: String,
      default: '284px'
    },

    maxHeight: {
      type: String,
      default: '200px'
    },

    cssClass: {
      type: String,
      default: null
    },

    forcedHeight: {
      type: [String, Number],
      default: null
    },

    forcedWidth: {
      type: [String, Number],
      default: null
    },

    minWidth: {
      type: [String, Number],
      default: null
    },

    isHeightDisabled: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      error: false
    }
  },
  computed: {
    containerStyle() {
      const style = {}
      if (this.maxWidth) style.maxWidth = `${this.maxWidth}`
      if (this.maxHeight) style.maxHeight = `${this.maxHeight}`
      if (this.forcedHeight) style.height = `${this.forcedHeight}px !important`
      if (this.forcedWidth) style.width = `${this.forcedWidth}px !important`
      if (this.minWidth) style.minWidth = `${this.minWidth}px !important`
      if (this.isHeightDisabled) style.height = 'unset !important'
      if (this.isHeightDisabled) style.maxHeight = 'unset !important'

    
      return style
    },
    showImage() {
      return !!this.image && !this.error
    },

    ...mapGetters([ 'getStore' ])
  },

  methods: {
    getImage(item) {
      const url = get(item, 'imageURL', null) || get(this.getStore, 'images.REWARD[0].url', null)

      if (!!url)
        return `${process.env.VUE_APP_API_IMAGE}${url}`
    },
    onImageError($event) {
      this.error = true
    }
  }
}
</script>

<style scoped>
  .imageContainer {
    display: flex;
    align-items: center;
    max-height: 100%;
  }
  .CardContainer {
    width: 100%;
    min-width: 200px;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .disabled {
    background-color: rgba(0,0,0,.12)!important;
  }

  .cart-count {
    display: inline-block;
    text-align: center;
    font-weight: bold;
    width: 32px;
    height: 32px;
    padding: 5px;
    background: var(--v-primary-base) !important;
    color: white;
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 1;
    box-sizing: border-box;
    border-radius: 0px 0px 0px 5px;
  }
  .cart-count ~ div .textBody {
    padding-right: 22px !important;
  }

  .v-image {
    border-radius: 5px;
  }
</style>
<style>
  .RewardsCard {
    text-align: left;
    padding: 10px 10px 10px;
    margin: 0px 0px 0px 0px;

    border-color: var(--v-primary-base) !important;
    border: solid;
    border-width: 2px 2px 2px 10px;
    border-radius: 5px;

    /* display: inline-block; */

    width: 100%;
    height: 100%;
    min-width: 200px !important;
    max-height: 106px !important;

    white-space:normal;
    overflow: hidden;
    background-color: white;
  }
  .RewardsCard .v-layout {
    flex: 1;
    display: flex;
  }

  .RewardsCard .header {
      font-size: 12px;
      font-weight: 600;
      color: var(--v-primary-base);

      -webkit-box-orient: vertical;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
  }
  .RewardsCard .subheader {
    font-size: 11px;
    font-weight: bold;
    color: grey;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
    max-width: 100%;
    margin-top: 5px;

  }
  .rewards-carousel {
    width: 100%;
    max-width: 90vw !important;
  }

  .rewards-slide {
    height: 100%;
    padding: 10px;
    display: flex;
  }

  .rewards-slide > div {
    width: 100%;
    height: 100%;
  }

  @media only screen and (max-width: 920px) {
    .RewardsCard {
      height: 160px;
    }
    .RewardsCard .subheader {
      margin-top: 0px;
    }
  }
/* .VueCarousel {
    width: 100%;
    max-width: 90vw !important;
  }

  .VueCarousel-wrapper {
    display: flex;
  }

  .VueCarousel-inner {
    display: flex;
    flex: 1;
  }

  .VueCarousel-slide {
    height: auto !important;
  } */
</style>
